export default "__VITE_ASSET__753152ec__"